export default __webpack_public_path__ + "static/media/logo-vertical.78a3c643.svg";